import snow from "../assets/pngwing.com (2).png"
export default snow 